<template>
  <van-collapse v-model="activeName" accordion class="legalinstitutions">
    <van-collapse-item
      title="智慧审判"
      name="2"
      class="legalinstitutions-item"
      :class="{ 'legalinstitutions-item-check': activeName == '2' }"
    >
      <div class="info">
        基层法院普遍面临案多人少工作负荷大的痛点，以高发、高似的民间借贷、金融借贷、买卖合同、道交等类型案件为切入点，综合应用机器视觉、语义识别、规则引擎、深度学习等人工智能技术，自动起草审判书供法官阅批，能为法官减少50%以上的基础书面案头工作时间，有效减轻法官的工作负荷，提升结案效率。
      </div>
      <img
        :src="product_society_society_zhsp"
        alt="智慧审判"
        class="legalinstitutions-img"
      />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.zhsp"
          :key="`legalinstitutions-item2-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span
            ><strong>{{ item.item }}</strong
            >{{ item.text }}</span
          >
        </div>
      </div>
    </van-collapse-item>
    <van-collapse-item
      title="智能法条检索工具"
      name="3"
      class="legalinstitutions-item"
      :class="{ 'legalinstitutions-item-check': activeName == '3' }"
    >
      <div class="info">
        实现法规法条精准检索，准确匹配历史相似事件，并提供关联处置部门的意见。对工作人员的处理提供参考依据，提高工作人员业务能力和工作效率，让工作的系统化、科学化、智能化、法治化。
      </div>
      <img
        :src="product_society_society_znft"
        alt="换届一件事"
        class="legalinstitutions-img"
      />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.znft"
          :key="`legalinstitutions-item3-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="智能法条检索工具" />
          <span
            ><strong>{{ item.item }}</strong
            >{{ item.text }}</span
          >
        </div>
      </div>
    </van-collapse-item>
    <van-collapse-item
      title="司法大模型"
      name="1"
      class="legalinstitutions-item"
      :class="{ 'legalinstitutions-item-check': activeName == '1' }"
    >
      <div class="info">
        华院Uni-Law司法领域大语言模型，旨在为数字法治赋能，核心思想是以“普法共享和司法效能提升”为目标，从推动法律智能化体系入司法实践、数字化案例建设、虚拟法律咨询服务赋能等方面提供支持，形成数字化和智能化的司法基座能力。
      </div>
      <img
        :src="product_society_society_sfdmx"
        alt="司法大模型"
        class="legalinstitutions-img"
      />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.sfdmx"
          :key="`legalinstitutions-item1-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span>{{ item }}</span>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>
<script>
import product_society_society_sfdmx from "@/../static/img/product/product_society_society_sfdmx.png";
import product_society_society_zhsp from "@/../static/img/product/product_society_society_zhsp.svg";
import product_society_society_znft from "@/../static/img/product/product_society_society_znft.svg";
import product_society_superiority from "@/../static/img/product/product_society_superiority.png";

export default {
  data() {
    return {
      product_society_society_sfdmx,
      product_society_society_zhsp,
      product_society_society_znft,
      product_society_superiority,
      activeName: "",
      advantageList: {
        zhsp: [
          { item: "轻应用：", text: "轻部署，即插即用无缝嵌入现有审判流程" },
          {
            item: "高智能：",
            text: "智能引擎自动分析案情并撰写判决书，简单易上手"
          },
          { item: "模块化：", text: "可拓展性强，覆盖面广" }
        ],
        znft: [
          {
            item: "法律法规覆盖全：",
            text: "国家法律、国家行政法律、地方性行政法规"
          },
          {
            item: "智能检索效率高：",
            text: "智能引擎精确定位相关法条、事件精准依法分类与办理"
          },
          {
            item: "法律结构化管控：",
            text: "相关法律修正时间做明确标注、方便识别"
          }
        ],
        sfdmx: [
          "法律问答",
          "知识检索增强问答",
          "法律文书生成",
          "推理决策",
          "意图识别",
          "案情分析"
        ]
      }
    };
  }
};
</script>
<style lang="less" scoped>
.legalinstitutions {
  width: 100%;
  /deep/.van-cell {
    height: 94px;
    font-size: 28px;
    color: #08204d;
    line-height: 94px;
    text-align: center;
  }
  /deep/ .van-cell__right-icon {
    display: none;
  }
  .legalinstitutions-item {
    padding: 0 64px;
    background: #ffffff;
    .info {
      font-size: 24px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
    }
  }
  .legalinstitutions-item-check {
    /deep/.van-cell__title::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 35%;
      width: 30%;
      height: 2px;
      background-color: blue;
    }
  }
  .legalinstitutions-img {
    width: 100%;
    margin: 44px 0;
  }
  .superiority {
    margin-bottom: 32px;
    .title {
      font-size: 26px;
      color: #08204d;
      line-height: 36px;
      margin-bottom: 24px;
      font-weight: 600;
    }
    .superiority-item {
      display: flex;
      font-size: 24px;
      color: #08204d;
      line-height: 32px;
      margin-bottom: 32px;
      > img {
        width: 32px;
        height: 32px;
        margin-right: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/society/modelAlgorithmTools.vue